import { AWARD_PAGE } from './actionTypes';

const initialState = {
  awards: null,
  loading: {
    awards: false,
  },
  error: {
    awards: null,
  },
};

const AwardReducer = (state = initialState, action) => {
  const { type, payload, error } = action;
  switch (type) {
    case AWARD_PAGE.AWARD_PAGE_REQUEST:
      return {
        ...state,
        loading: { ...state.loading, awards: true },
        error: { ...state.error, awards: null },
      };
    case AWARD_PAGE.AWARD_PAGE_SUCCESS:
      return {
        ...state,
        awards: payload,
        loading: { ...state.loading, awards: false },
      };
    case AWARD_PAGE.AWARD_PAGE_FAILURE:
      return {
        ...state,
        loading: { ...state.loading, awards: false },
        error: { ...state.error, awards: error },
      };
    default:
      return state;
  }
};

export default AwardReducer;
